<template>
  <div>


    <!-- <b-navbar-toggle target="side-nav" style="float:left;">
        <template>
          <div style="border:solid 1px black;border-radius:3px;font-size: 1.5rem;">
          <b-icon icon="list"></b-icon>
        </div>
        </template>
      </b-navbar-toggle> -->

<b-container class="side-n" id=""  >
  <!-- <b-collapse id="side-nav" is-nav class="nav-bgcolor"> -->

  <!-- <b-row class="custom-row" >
    <b-col>
      <b-button @click="goto('office')" block squared id="boffice" class=" btn-color btn-color-active">
        Registered Office
      </b-button></b-col>
  </b-row> -->
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('customerCare')" block squared id="bcustomerCare" class=" btn-color btn-color-active">
    APDCL Customer Care
  </b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('kofficial')" block squared id="bkofficial" class=" btn-color">
    Key Officials (HQ) Contact Details
  </b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button  @click="goto('zone')" block squared id="bzone" class=" btn-color">
      Zone Contact Details</b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('circle')" block squared id="bcircle" class=" btn-color">
      Circle Contact Details</b-button></b-col>
  </b-row>

  <b-row class="custom-row">
    <b-col ><b-button @click="goto('division')" block squared id="bdivision" class=" btn-color">
    Division Contact Details</b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('subdivision')" block squared id="bsubdivision" class=" btn-color">
    Sub-Division Contact Details</b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('irca')" block squared id="birca" class=" btn-color">
      IRCA Contact Details
      </b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('tc')" block squared id="btc" class=" btn-color">
    T&C Division Contact Details</b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('agm')" block squared id="bagm" class=" btn-color">
      District-wise AGM(Project)</b-button></b-col>
  </b-row>
<!-- </b-collapse> -->
</b-container>

</div>
</template>
<script>
export default
 {

  methods: {
  /*goto(refName) {
     var element=document.getElementById(refName);
     var btn_id='b' + refName;
     var btn=document.getElementById(btn_id);
     element.scrollIntoView({  behavior: 'smooth', block: 'start', inline: 'start'  });
     document.querySelector(".btn-color-active").classList.remove("btn-color-active");
     btn.classList.add("btn-color-active");
   }*/

   goto(refName) {
  
  document.querySelectorAll('.section-content').forEach(div => {
    div.style.display = 'none';
  });

  
  var element = document.getElementById(refName);
  element.style.display = 'block';


  element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });

  // Button highlighting
  var btn_id = 'b' + refName;
  var btn = document.getElementById(btn_id);
  document.querySelector(".btn-color-active").classList.remove("btn-color-active");
  btn.classList.add("btn-color-active");
}

  }
}
</script>
<style scoped="true">
.custom-row {
  margin-right: 0;
  margin-left: 0;
  height:50px;
}

.btn-block{
  height:100%;
  width:100% !important;
  text-align: left;
  font-size: 0.9rem;
  font-weight: 500;
  letter-spacing: 0.2px;
  border:none;
  border-bottom:1px solid;

}


.btn-color{
  color: #616161    ;
  background-color: #ffff;
  border-color: #e0e0e0 ;
  transition:0.3s;
 }
.btn-color:hover
{
  color: #ffff;
  background-color: #0277bd     ;
  border-color: #0277bd     ;
}
.btn-color-active
{
  color: #ffff;
  background-color: #0288d1    ;
  border-color: #0288d1    ;
  box-shadow: none;
}

.side-n{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
width:100%;
 overflow-y: auto;
  max-height: calc(100vh - 150px); /* Adjust based on header size */

}

.container,.col
{
  padding-left:0;
  padding-right: 0;
}

</style>
